export default {"src":"/_next/static/media/grc.26003a43.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};